module.exports = __webpack_public_path__ + "img/icon-appstore-android-dark.5d8fadf4.svg";